import React, { useState, useEffect, useRef } from 'react'
import { Input, Dropdown, Button, WaterMark, SafeArea, Toast, SpinLoading, PullToRefresh, InfiniteScroll, ErrorBlock } from 'antd-mobile'
import { useNavigate } from "react-router-dom";
import * as api from '../../services/api';
import { useOKRequest, useScrollOKRequest } from '../../hooks';
import { getAuth, clearAuth } from '../../modules/auth';
import './patientList.css';

function PatientList() {
  const navigate = useNavigate();
  const [value, setValue] = useState('') // 搜索框数据
  const [selectedId, setSelectedId] = useState(null); //选择的用户
  const [deviceId, setDeviceId] = useState(null); //选择的设备
  const [loading, setLoading] = useState(true);
  // console.log('selectedId', selectedId)

  const scrollDomRef = useRef()

  // 获取患者列表接口
  // const [patientList, setPatientList] = useState([])
  const { loading: listLoding, data: patientList, run: getPatientList } = useScrollOKRequest(api.getPatientList, {
    manual: true,
    scrollDomRef,
    onSuccess: (res) => {
      // setPatientList(dataArr)
      setLoading(false); // 请求成功后设置 loading 为 false
    },
    onError: (err) => {
      Toast.show({
        content: '请求失败',
      });
      setLoading(false); // 请求失败后也设置 loading 为 false
    },
  });
  // 获取设备列表
  // const { data, run: getPatientList } = useOKRequest(() =>
  //   api.getPatientList({
  //     username: getAuth()?.username,
  //     departIds: getAuth()?.departIds,
  //     pageNo,
  //     pageSize: 10,
  //     name: value,
  //   }), {
  //   onSuccess: (res) => {
  //     setPatientList(res?.data?.result?.records)
  //     setLoading(false); // 请求成功后设置 loading 为 false
  //   },
  //   onError: (err) => {
  //     Toast.show({
  //       content: '请求失败',
  //     });
  //     setLoading(false); // 请求失败后也设置 loading 为 false
  //   },
  // }
  // );
  console.log('patientList', patientList)


  // 获取设备列表
  const { data: deviceObj, run: gainPatientDeviceList } = useOKRequest(() =>
    api.gainPatientDeviceList({
      // sysId: 'f33fc2875b444d369ffd05b6b0d7e2b8'
      sysId: getAuth()?.departIds,
    }), {
    manual: true,
  }
  );
  const deviceList = deviceObj?.data?.result;
  // console.log('deviceList', deviceList)

  // 绑定设备
  const { loading: bindLoading, run: dealPatientDevice } = useOKRequest(api.dealPatientDevice, {
    manual: true,
    onSuccess: (res) => {
      Toast.show({
        content: res.data.message,
      })
      if (res.data.code === 200) {
        gainPatientDeviceList()
      }
    },
  });

  // 设备解绑
  const { loading: UnbindLoading, run: dealPatientDeviceUnbind } = useOKRequest(api.dealPatientDeviceUnbind, {
    manual: true,
    onSuccess: (res) => {
      Toast.show({
        content: res.data.message,
      })
      if (res.data.code === 200) {
        gainPatientDeviceList()
      }
    },
  });

  useEffect(() => {
    const params = {
      username: getAuth()?.username,
      departIds: getAuth()?.departIds,
      pageNo: 1,
      pageSize: 10,
      name: value,
    }
    getPatientList(params)
    // getPatientList()
  }, []);

  // 组件实现下拉加载
  // const [pageNo, setPageNo] = useState(1)
  // const [hasMore, setHasMore] = useState(true)
  // const [data, setData] = useState([])
  // async function loadMore() {
  //   const msg = await api.getPatientList({
  //     username: getAuth()?.username,
  //     departIds: getAuth()?.departIds,
  //     pageNo,
  //     pageSize: 10,
  //     name: value,
  //   });
  //   console.log('msg', msg)
  //   setData(val => [...val, msg.data.result.records])
  //   setHasMore(msg.data.result.records.length > 0)
  //   if (msg.data.result.records.length > 0) {
  //     setPageNo(pageNo + 1);
  //   }
  // }
  // console.log('datadatadata', data)

  return (
    <div className='PatientList'>
      {/* <WaterMark content='河北省人民医院 李旭康' /> */}
      <WaterMark fontColor='rgba(0, 0, 0, .1)' content={[getAuth()?.depart_name, getAuth()?.realname]} />
      <div className="PatientList_top">
        <div className='PatientList_topTitle'>{getAuth()?.depart_name}</div>
        <div className='PatientList_topRight'>
          {/* <span className='PatientList_topRight-name'>李旭康</span>
          <img src="./images/pull.png" alt="" /> */}
          <Dropdown arrow={<img src="./images/pull.png" alt="" />}>
            <Dropdown.Item
              key='item'
              title={<span className='PatientList_topRight-name'>{getAuth()?.realname}</span>}
            >
              <div className='PatientList_Dropdown'>
                <Button
                  className="PatientList_Dropdown-btn"
                  onClick={() => navigate('/modifyPassword')}
                >修改密码</Button>
                <Button
                  className="PatientList_Dropdown-btn"
                  style={{ paddingTop: 0 }}
                  onClick={() => {
                    navigate('/')
                    clearAuth()
                  }}
                >退出登录</Button>
              </div>
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>
      {getAuth()?.roleName ? <div>
        <div className="PatientList_listTop">
          <div className="PatientList_listTopTitle">患者列表</div>
          <img
            src="./images/add.png"
            alt=""
            onClick={() => navigate('/addPatient')}
          />
        </div>
        <div className="PatientList_listContent">
          <div className="PatientList_searchInputContainer">
            <Input
              className='PatientList_searchInput'
              style={{
                padding: '0 16px 0 52px',
                backgroundImage: 'url("./images/search.png")',
              }}
              placeholder='搜索患者'
              clearable
              value={value}
              onChange={val => {
                setValue(val)
              }}
              onEnterPress={(e) => {
                console.log('搜索', value)
                setLoading(true)
                e.target.blur(); // 移除光标
                const params = {
                  username: getAuth()?.username,
                  departIds: getAuth()?.departIds,
                  pageNo: 1,
                  pageSize: 10,
                  name: value,
                }
                getPatientList(params)
              }}
            />
          </div>
          <PullToRefresh
            onRefresh={async () => {
              const params = {
                username: getAuth()?.username,
                departIds: getAuth()?.departIds,
                pageNo: 1,
                pageSize: 10,
                name: value,
              }
              getPatientList(params)
            }}
          >
            <div id={scrollDomRef} className={`PatientList_listContainer ${(patientList?.length === 0 || loading) ? 'flex_center' : ''}`}>
              {loading ? <SpinLoading /> :
                patientList?.length !== 0 ? patientList?.map((item) => <div key={item.id}>
                  <div className="PatientList_listItem">
                    <div
                      className="PatientList_listItem-left"
                      onClick={() => {
                        const params = item;
                        const queryString = new URLSearchParams(params).toString();
                        navigate(`/patientDetails?${queryString}`)
                      }}
                    >
                      <img
                        src={item.sex === '男' ? './images/avator2.png' : './images/avator1.png'}
                        alt="" />
                      <div className='PatientList_listItem-leftInfo'>
                        <div className="PatientList_listItem-leftName">{item.name}</div>
                        <div className="PatientList_listItem-leftSex">{item.sex} {item.age}岁</div>
                      </div>
                    </div>
                    <Button
                      className={`PatientList_listItem-right ${selectedId === item.id ? 'selected' : ''}`}
                      onClick={() => {
                        setSelectedId((prevSelectedId) => (prevSelectedId === item.id ? null : item.id));
                        gainPatientDeviceList()
                      }}
                    >
                      院内训练
                    </Button>
                  </div>
                  {selectedId === item.id &&
                    (deviceList && deviceList.length > 0 ? (
                      deviceList.map((device) => (
                        <div key={device.deviceId} className="PatientList_itemBottom">
                          <div className='PatientList_itemBottom-left'>
                            <img src="./images/device.png" alt="" />
                            <div style={{ marginLeft: '10px' }}>
                              <div className="PatientList_itemBottom-text1">{device.deviceNo}</div>
                              <div className="PatientList_itemBottom-text2">授权至 {device.deadline}</div>
                            </div>
                            <div style={{ marginLeft: '16px' }}>
                              {device.status === '已绑定用户' ? <>
                                <div className="PatientList_itemBottom-text1">当前用户</div>
                                <div className="PatientList_itemBottom-text2">{device.bindName}</div>
                              </> :
                                <div className="PatientList_itemBottom-text3">空闲</div>
                              }
                            </div>
                          </div>
                          {device.status === '已绑定用户' ? <Button
                            className="PatientList_itemBottom-btn"
                            loading={deviceId === device.deviceId ? UnbindLoading : false}
                            onClick={() => {
                              setDeviceId((prevDeviceId) => (prevDeviceId === device.deviceId ? null : device.deviceId));
                              dealPatientDeviceUnbind({ deviceId: device.deviceId })
                              // console.log('device.deviceId',device.deviceId)
                            }}
                          >
                            解绑
                          </Button>
                            :
                            <Button
                              className="PatientList_itemBottom-btn"
                              loading={deviceId === device.deviceId ? bindLoading : false}
                              onClick={() => {
                                setDeviceId((prevDeviceId) => (prevDeviceId === device.deviceId ? null : device.deviceId));
                                const params = {
                                  deadline: device.deadline,
                                  deviceId: device.deviceId,
                                  no: item.no,
                                }
                                dealPatientDevice(params);
                                // console.log('device.deviceId',device.deviceId)
                              }}
                            >
                              选择
                            </Button>
                          }
                        </div>
                      ))
                    ) : (
                      <div className="PatientList_itemBottom">
                        <div className='PatientList_itemBottom-left'>
                          <div style={{ marginLeft: '10px' }}>
                            <div className="PatientList_itemBottom-text1">暂无院内训练终端</div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
                )
                  :
                  <div className="PatientList_noData">
                    <img src="./images/noData.png" alt="" />
                    <div className="PatientList_noData-text">未找到数据</div>
                  </div>
              }
              {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore} /> */}
            </div>
          </PullToRefresh>
        </div>
      </div>
        :
        // <div className='PatientList_tip'>
        //   该账号暂无权限，<br />请联系系统管理员
        // </div>
        <ErrorBlock 
        fullPage 
        image='https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg'
        title={<div className='PatientList_tip'>该账号暂无权限，<br/>请联系系统管理员</div>} 
        description='' />
      }

      <SafeArea position='bottom' />
    </div >
  );
}

export default PatientList;
